module.exports = __webpack_public_path__ + "static/mystuff-bg-2e629ae3badf0f72a39626ae84deb6e1.jpg";